import { Box, Paper, Skeleton } from "@mui/material";
import React from "react";
import CardSkeletonLoader from "./CardSkeletonLoader";
import EntityDetailsPageHeaderSkeleton from "./EntityDetailsPageHeaderSkeleton";
import FundsDetailsSkeleton from "./FundsDetailsSkeleton";

type EntityDetailsPageSkeletonProps = {
  withFunds?: boolean;
};

const EntityDetailsPageSkeleton = ({
  withFunds = false,
}: EntityDetailsPageSkeletonProps) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "calc(100vh - 40px)",
        backgroundColor: "background.default",
        px: 3,
        display: "flex",
        flexDirection: "column",
        gap: 4,
        overflowY: "hidden",
      }}
    >
      {/* Header */}
      <EntityDetailsPageHeaderSkeleton breadcumbsLength={2} hasFollowButton />

      {withFunds && <FundsDetailsSkeleton />}

      {/* Tabs */}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          borderRadius: ".5em .5em 0 0",
        }}
      >
        <Paper
          sx={{
            flex: 1,
            backgroundColor: "background.paper",
            borderRadius: ".5em .5em 0 0",
          }}
        >
          <Box
            sx={{
              height: "48px",
              backgroundColor: "white",
              borderRadius: ".5em .5em 0 0",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "start",
                alignItems: "center",
                gap: 2,
                pl: "20px",
                height: "100%",
              }}
            >
              {[...Array(3)].map((_, i) => (
                <Skeleton key={i} width="90px" height="24px" sx={{ px: 1 }} />
              ))}
            </Box>
          </Box>
          <Box sx={{ backgroundColor: "background.paper", py: 1 }}>
            {[...Array(3)].map((_, i) => (
              <CardSkeletonLoader key={i} />
            ))}
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default EntityDetailsPageSkeleton;
